import PropTypes from 'prop-types'
import React, { Component } from 'react'
import classNames from 'classnames'
import { connect } from 'react-redux'

import { UserAvatar } from 'components/Utils/Avatar'
import { Name, Detail } from 'components/base/Text'

import { record as UsersRecord, selectors as UsersSelectors } from 'data/users'
import { getLabel } from 'data/users/record'

class UsersPickerRow extends Component {
  static propTypes = {
    user: PropTypes.instanceOf(UsersRecord).isRequired,
    onSelect: PropTypes.func.isRequired,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    className: PropTypes.string,
  }

  render() {
    const { user, onSelect, onFocus, onBlur, className } = this.props
    return (
      <div
        className={classNames([
          className,
          'user-picker-row',
          'flexbox flexbox-row flexbox-align-center',
          'pointer background-shade-100 background-shade-50-on-focus background-shade-50-on-hover',
          'padding-normal no-outline',
        ])}
        onClick={onSelect}
        onFocus={onFocus}
        onBlur={onBlur}
        tabIndex="-1"
      >
        <UserAvatar
          className="border-none"
          userId={user.get('id')}
          size="small"
        />
        <Name className="margin-horizontal-normal">@{user.username}</Name>
        <Detail>
          {user.invitePending
            ? `${user.email} will be notified`
            : getLabel(user)}
        </Detail>
        <div className="shortcut-focus margin-left-auto shade-20">
          <span className="font-weight-bold">↵</span> to add
        </div>
        <div className="shortcut-hover margin-left-auto shade-20">
          <span className="font-weight-bold">Click</span> to add
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, { id }) => ({
  user: UsersSelectors.getUser(state, id),
})

export default connect(mapStateToProps)(UsersPickerRow)
